<template>
  <div class="login-wrapper">

    <div class="login">

      <img src="/static/img/suez-white.png" class="logo"/>

      <h2>Service Complet</h2>
      <h3>Backoffice</h3>

      <!-- login form -->
      <form class="ui form loginForm" v-on:submit.prevent="submit">

        <div class="input-group">
          <span class="input-group-addon"><i class="fa fa-user"></i></span>
          <input class="form-control" name="username" placeholder="Utilisateur" type="text" v-model="username">
        </div>

        <div class="input-group">
          <span class="input-group-addon"><i class="fa fa-lock"></i></span>
          <input class="form-control" name="password" placeholder="Password" type="password" v-model="password">
        </div>

        <message
          :obj=login.message
          hide-mutation-type="CLEAR_LOGIN_MESSAGE">
        </message>
        <a href="#" v-on:click="forgotPassword" class="forgot-password"> > Mot de passe oublié ? </a>
        <div v-if="login.loggedIn"
             class="callout callout-success">
          <p>Bienvenue !</p>
        </div>

        <button type="submit" v-bind:class="'btn btn-primary btn-lg'">S'identifier
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import api from '../store/api'
import Message from './shared/Message'
import jwt from 'jsonwebtoken'

export default {
  name: 'Login',
  computed: {
    ...mapState([
      'login',
    ]),
  },
  data (router) {
    return {
      username: '',
      password: '',
      jwtToken: ''
    }
  },
  methods: {
    submit () {
      this.$store.dispatch('loginV2', {
        username: this.username,
        password: this.password,
      })
    },
    decodeToken () {
      try {
        console.log('decode')
        const decodedToken = jwt.decode(this.jwtToken)

        if (decodedToken) {
          this.tokenUsername = decodedToken.sub
          this.tokenExpirationDate = new Date(decodedToken.exp * 1000)
        }
      } catch (error) {
        console.error('Error decoding JWT token:', error)
      }
    },
    forgotPassword: function () {
      console.log("nssit")
       this.$store.dispatch('forgotPassword', this.username)
    },
  },
  components: {
    Message,
  },
  mounted () {
    /* if (api.canTryLogin()) {
      this.$store.dispatch('loginWithSavedCredentials')
    } */
    console.log('loading : ', this.login.loading)
    let token = localStorage.getItem('TOKEN')
    this.jwtToken = token
    this.decodeToken()
    console.log('this.tokenUsername ::: ', this.tokenUsername)
    if (token) {
      console.log('yeees boyyyyyy :: ', token)
      this.$store.dispatch('loginWithToken', {
        login: this.tokenUsername
      })
    }
  },
  updated () {
    /*     if (this.$store.state.login.loggedIn) {
          var query = this.$route.query.redirect
          if (query.substring(0, query.lastIndexOf('/') + 1) === '/anomalies/image/') {
            this.$router.push({name: 'Image-anomalie', params: {id: query.split('/')[3]}})
          } else {
            this.$router.push('/')
          }
        } */
    if (this.$store.state.login.loggedIn) {
      if (this.$route && this.$route.query && this.$route.query.redirect) {
        this.$router.push(this.$route.query.redirect)
      } else {
        this.$router.push('/')
      }
    }
  },
}
</script>

<style lang="scss">

@import '../scss/variables';


.login-wrapper {
  background-color: $suez-blue;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;

  .login {
    width: 350px;

    .logo {
      max-width: 300px;
      padding: 0;
      margin: 0 auto;
      display: block;
      margin-bottom: 3rem;
    }

    h2, h3 {
      text-align: center;
      color: white;
      margin: 0;
    }

    form {
      margin-top: 3rem;

      .input-group {
        width: 100%;
        margin-bottom: 1rem;
      }

      .input-group-addon {
        width: 40px;
      }

      button {
        margin: 0 auto;
        margin-top: 3rem;
        display: block;

        &.loading {
          opacity: 0.4;
          pointer-events: none;
        }
      }
    }

  }
}

.forgot-password {
  margin-left: 58%;
  color: $suez-green;
}


</style>



// WEBPACK FOOTER //
// Login.vue?d4a91488